/**
 * @param {Array<import('../../../../../../type-definitions').SizeRegion>} sizeMap - size map
 * @returns {string} region dropdown HTML
 */
export default sizeMap => {
    return `
        <div class="regions">
            <div class="form-row form-row-radio form-row-radio-multi form-row-radiogroup">
                <div class="input-radiogroup">
                    ${sizeMap
                        .map(
                            region => `
                                <div class="form-row form-row-radio region-select ${region.selected ? 'selected' : ''}"
                                    data-region="${region.name}">
                                    <input class="input-radiobutton" type="radio" name="size-region-desktop"
                                        id="${region.name}-desktop"
                                        value="${region.name}" aria-checked="${region.selected ? 'true' : 'false'}"
                                        ${region.selected ? 'checked' : ''}/>
                                        <label for="${region.name}-desktop" class="label js-size-label" role="radio"
                                            tabindex="0" aria-checked="${region.selected ? 'true' : 'false'}">
                                            ${region.name}
                                        </label>
                                </div>
                            `
                        )
                        .join('')}
                </div>
            </div>
        </div>
    `;
};
